import {SortingOptions} from '@/modules/common/context/QueryParams/models';

const SORT_LIST_NAME_MAP = {
  [SortingOptions.priceAsc]: 'hotel list - lowest price',
  [SortingOptions.ratingDesc]: 'hotel list - best user rating',
  [SortingOptions.categoryDesc]: 'hotel list - highest stars',
};

export const mapToSortListNameForHotel = (sortBy: string): string =>
  // @ts-expect-error ...
  SORT_LIST_NAME_MAP[sortBy] || 'hotel list - recommendation';
